import { render, staticRenderFns } from "./NewActivity.vue?vue&type=template&id=165ec162&scoped=true&"
import script from "./NewActivity.vue?vue&type=script&lang=js&"
export * from "./NewActivity.vue?vue&type=script&lang=js&"
import style0 from "./NewActivity.vue?vue&type=style&index=0&id=165ec162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ec162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165ec162')) {
      api.createRecord('165ec162', component.options)
    } else {
      api.reload('165ec162', component.options)
    }
    module.hot.accept("./NewActivity.vue?vue&type=template&id=165ec162&scoped=true&", function () {
      api.rerender('165ec162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewActivity.vue"
export default component.exports